import { useQuery } from "@tanstack/react-query";
import { getMonthlyForecastWholesale } from "../services/wholesaleForecastMonthlyService";

export const useMonthlyForecastWholesale = (month = "2025-04") => {
  return useQuery({
    queryKey: ["wholesale-monthlyForecast", month],
    queryFn: () => getMonthlyForecastWholesale(month),
    staleTime: 1000 * 60 * 5,
  });
};